import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig'; 
import FormComponent from '../../../Reusable_Components/FormComponent'; // Adjust path
import { useParams } from 'react-router-dom';

const QuoteCommentInput = ({  }) => {
  const [formData, setFormData] = useState({}); // Empty state initially
  const [quotes, setQuotes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id = '' } = useParams(); // Get the quote ID if you're editing
  const decodedId = id ? atob(id) : id;
  const commentId = decodedId.replace(/\D/g, '');
  const isEditing = Boolean(commentId);

  const route = 'quoteComments'; // Define the route for your API

  useEffect(() => {
    if (commentId) {
      fetchCommentDetails(commentId);
    }
    fetchQuotes();
    fetchUsers();
  }, [commentId]);

  // Function to fetch comment details for editing
  const fetchCommentDetails = async (id) => {
    try {
      
      
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quoteComments}/${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching comment details:', error);
    }
  };

  // Fetch quotes for the "Quote" select field
  const fetchQuotes = async () => {
    try {
      
      
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quote}`, { headers });
      const quoteOptions = response.data.map((quote) => ({
        value: quote.id,
        label: quote.quote_number,
      }));
      setQuotes(quoteOptions);
    } catch (error) {
      console.error('Error fetching quotes:', error);
    }
  };

  // Fetch users for the "User" select field
  const fetchUsers = async () => {
    try {
      
      
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.users}`, { headers });
      const userOptions = response.data.map((user) => ({
        value: user.id,
        label: user.username,
      }));
      setUsers(userOptions);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    

    const url = isEditing
      ? `${API_DOMAIN}${API_ROUTES.quoteComments}/${commentId}/`
      : `${API_DOMAIN}${API_ROUTES.quoteComments}/`;

    try {
      if (isEditing) {
        await axios.put(url, formData, { headers });
      } else {
        await axios.post(url, formData, { headers });
      }
      alert(isEditing ? 'Comment updated successfully!' : 'Comment created successfully!');
    } catch (error) {
      console.error('Error saving comment:', error);
      alert('An error occurred while saving the comment.');
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { name: 'quote', label: 'Quote', type: 'select', options: quotes },
    { name: 'user', label: 'User', type: 'select', options: users },
    { name: 'text', label: 'Comment Text', type: 'textarea' }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Comment' : 'Create Quote Comment'}</h1>
      <FormComponent fields={fields} initialFormData={formData} onSubmit={handleSubmit} loading={loading} route={route} />
    </div>
  );
};

export default QuoteCommentInput;
